package com.exura.features.newauth.domain.model

abstract class AuthUser(
    val userType: UserType,
    val userRole: UserRole,
) {
    abstract val id: String
    abstract val email: String
}
